// APP-104 §3.2a: the first time a click would start recording, a short introduction comes first.
// Once the person has started recording or chosen to type from it, it isn't shown again in this
// browser. It's a per-viewer convenience, like the header overrides: the browser asks for the
// microphone once per browser too, and with storage missing (a private window, cleared site data)
// the introduction is simply shown again.

const STORAGE_KEY = 'mrv2.feedbackVoiceIntro';

/** People this page load already took through it, for a browser that won't store it. */
const seenHere = new Set<string>();

/** The people this browser has taken through it (people may share a browser). */
function readSeen(): string[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

/** Has this person been through the introduction in this browser? */
export function voiceIntroSeen(personId: string): boolean {
  return seenHere.has(personId) || readSeen().includes(personId);
}

/** Records that this person has been through it. */
export function markVoiceIntroSeen(personId: string): void {
  seenHere.add(personId);
  const seen = readSeen();
  if (seen.includes(personId)) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify([...seen, personId]));
  } catch {
    // Storage is full or blocked: it still holds until the page reloads.
  }
}
